import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "react-oidc-context";
import { ProductsProvider } from './contexts/ProductsContext';

// Configuración OIDC para AWS Cognito
// Nota: Ajusta estos valores según tu configuración de Cognito
// Las variables de entorno deben comenzar con REACT_APP_ para que sean accesibles
const postLogoutRedirectUri = process.env.REACT_APP_REDIRECT_LOGOUT_URI || `${window.location.origin}/logout-callback`;
const postLoginRedirectUri = process.env.REACT_APP_REDIRECT_URI || `${window.location.origin}/callback`;

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  // El redirect_uri debe coincidir exactamente con el configurado en Cognito
  redirect_uri: postLoginRedirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri, // Redirigir directamente al origen
  response_type: 'code',
  scope: "phone openid email profile",
  // ✅ Configuraciones adicionales importantes
  loadUserInfo: true, // Evita problemas con userinfo endpoint
  filterProtocolClaims: true,
  automaticSilentRenew: true, // Habilitar renovación automática del token
  // Configuración para detectar cuando el usuario es eliminado
  checkSessionInterval: 30000, // Verificar sesión cada 30 segundos
  // Callback cuando hay un error de autenticación
  onSigninCallback: () => {
    // Usuario autenticado correctamente
  },
  // Callback cuando el usuario es eliminado o el token es inválido
  onSignoutCallback: () => {
    // Limpiar almacenamiento
    localStorage.clear();
    sessionStorage.clear();
  },
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();